<div style="padding:15px;">
    <div class="card" style="width:100%;" id="InsuredInfo">
        <ul class="nav nav-tabs listdata" role="tablist">
            <li role="presentation" class="active">
                <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Insured Info'|translate}}</a>
            </li>
        </ul>
        <div class="tab-content detailsTab">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="InsuredForm">
                    <form #insuredForm="ngForm" oncontextmenu="false" oncopy="false" onpaste="false" oncut="false">
                        <div class="Field">
                            <div class="row">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Prefix'|translate}}*</label>
                                    <select class="form-control" required name="txtPrefix" id="txtPrefix"
                                        [(ngModel)]="proposalObj.Prefix" [disabled]="false" #txtPrefix="ngModel"
                                        autocomplete="off">
                                        <option value="">--{{'Select Prefix'|translate}}--</option>
                                        <option *ngFor="let p of medmalBindObj.prefixList" [value]="p.PrefixId">
                                            {{ Lng=="en"? p.PrefixDescEn : p.PrefixDescAr }}</option>
                                    </select>
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Prefix Required"></span> -->
                                    <span *ngIf="txtPrefix.invalid && (txtPrefix.dirty || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtPrefix.errors?.required">
                                            {{'Prefix is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Gender'|translate}}</label>
                                    <select class="form-control" required name="txtGender" id="txtGender"
                                        [(ngModel)]="proposalObj.Gender" [disabled]="proposalObj.Gender_Exists"
                                        #txtGender="ngModel" autocomplete="off">
                                        <option value="">--{{'Select Gender'|translate}}--</option>
                                        <option *ngFor="let gen of medmalBindObj.genderList" [value]="gen.GenderCode">
                                            {{ Lng=="en"? gen.GenderDesc_En : gen.GenderDesc_Ar }}</option>
                                    </select>
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Gender Required"></span> -->
                                    <span *ngIf="txtGender.invalid && (txtGender.dirty || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtGender.errors?.required">
                                            {{'Gender is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Date of birth'|translate}}</label>
                                    <input type="text" class="form-control" required name="txtDOB" id="txtDOB"
                                        [(ngModel)]="proposalObj.IDOBStr" [disabled]="true" #txtDOB="ngModel"
                                        autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="DOB Required"></span> -->
                                    <span *ngIf="txtDOB.invalid && (txtDOB.dirty || isSubmitted)" class="text-danger">
                                        <div *ngIf="txtDOB.errors?.required">
                                            {{'DOB is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <!-- <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Date Of Birth(Hijri)'|translate}}</label>
                                    <input type="text" class="form-control" required name="txtDOBHijri" id="txtDOBHijri"
                                        [(ngModel)]="proposalObj.HDOB" [disabled]="true" #txtDOBHijri="ngModel"
                                        autocomplete="off" />
                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="DOB Hijri Required"></span>
                                    <span *ngIf="txtDOBHijri.invalid && (txtDOBHijri.dirty || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtDOBHijri.errors?.required">
                                            {{'DOB Hijri is required'|translate}}
                                        </div>
                                    </span>
                                </div> -->
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Insured Name'|translate}}</label>
                                    <input type="text" class="form-control" required id="txtName" name="txtName"
                                        required [(ngModel)]="proposalObj.Insured_Name" #txtName="ngModel"
                                        autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Insured Name is Required"></span> -->
                                    <span *ngIf="txtName.invalid && (txtName.dirty || isSubmitted)" class="text-danger">
                                        <div *ngIf="txtName.errors?.required">
                                            {{'Insured Name is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="Field">
                            <div class="row">
                               
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Nationality'|translate}}* </label>
                                    <select class="form-control" required name="txtNat" id="txtNat"
                                        [(ngModel)]="proposalObj.Insured_Nationality"
                                        [disabled]="proposalObj.Nat_Exists" #txtNat="ngModel" autocomplete="off">
                                        <option value="">--{{'Nationality'|translate}}--</option>
                                        <option *ngFor="let nat of medmalBindObj.natList" [value]="nat.NATCode">
                                            {{ Lng=="en"? nat.NATNameEn : nat.NATNameAr }}</option>
                                    </select>
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Insured Nationality is  Required"></span> -->
                                    <span *ngIf="txtNat.invalid && (txtNat.dirty || isSubmitted)" class="text-danger">
                                        <div *ngIf="txtNat.errors?.required">
                                            {{'Nationality is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'City'|translate}}</label>
                                    <select class="form-control" id="txtCity" required name="txtCity"
                                        [(ngModel)]="proposalObj.ICity" [disabled]="proposalObj.cityExists"
                                        #txtCity="ngModel" autocomplete="off">
                                        <option value="">---{{'Select City'|translate}}--</option>
                                        <option *ngFor="let cty of medmalBindObj.cityList" [value]="cty.CityCode">
                                            {{ Lng=="en"? cty.CityNameEn:cty.CityNameAr }}</option>
                                    </select>
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="City Required"></span> -->
                                    <span *ngIf="txtCity.invalid && (txtCity.dirty || txtCity.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtCity.errors?.required">
                                            {{'City is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                    <label class="lbltext">{{'Building No'|translate}}</label>
                                    <input type="text" class="form-control" required numbersOnly
                                        name="txtBuildingNumber" id="txtBuildingNumber"
                                        [(ngModel)]="proposalObj.Insured_BuildingNo"
                                        [disabled]="proposalObj.buildingNumberExists" #txtBuildingNumber="ngModel"
                                        minlength="4" maxlength="4" pattern="^[1-9]\d*$" autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Building No Required"></span> -->
                                    <span
                                        *ngIf="txtBuildingNumber.invalid && (txtBuildingNumber.dirty || txtBuildingNumber.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtBuildingNumber.errors?.required">
                                            {{'BuildingNumber is required'|translate}}
                                        </div>
                                        <div *ngIf="txtBuildingNumber.errors?.pattern">
                                            {{'BuildingNumber must Allow Only Numerics and Should Not start with Zero'|
                                            translate }}
                                        </div>
                                        <div *ngIf="txtBuildingNumber.errors?.minlength">
                                            {{'BuildingNumber must be 4 digits'|translate}}
                                        </div>
                                        <div *ngIf="txtBuildingNumber.errors?.maxlength">
                                            {{'BuildingNumber must be 4 digits'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                    <label class="lbltext">{{'Additional Code'|translate}}</label>
                                    <input type="text" class="form-control" required numbersOnly
                                        name="txtAdditionalNumber" id="txtAdditionalNumber"
                                        [(ngModel)]="proposalObj.Insured_AdditionalCode"
                                        [disabled]="proposalObj.additionalNumberExists" #txtAdditionalNumber="ngModel"
                                        minlength="4" maxlength="4" pattern="^[1-9]\d*$" autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Default popover"></span> -->
                                    <span
                                        *ngIf="txtAdditionalNumber.invalid && (txtAdditionalNumber.dirty || txtAdditionalNumber.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtAdditionalNumber.errors?.required">
                                            {{'AdditionalNumber is required'|translate}}
                                        </div>
                                        <div *ngIf="txtAdditionalNumber.errors?.pattern">
                                            {{'AdditionalNumber must Allow Only Numerics and Should Not start with Zero'| translate }}
                                        </div>
                                        <div *ngIf="txtAdditionalNumber.errors?.minlength">
                                            {{'AdditionalNumber must be 4 digits'|translate}}
                                        </div>
                                        <div *ngIf="txtAdditionalNumber.errors?.maxlength">
                                            {{'AdditionalNumber must be 4 digits'|translate}}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="Field">
                            <div class="row">
                                
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Street Name'|translate}}</label>
                                    <input type="text" class="form-control" required name="txtStreetName"
                                        id="txtStreetName" [(ngModel)]="proposalObj.Insured_StreetName"
                                        [disabled]="proposalObj.streetNameExists" #txtStreetName="ngModel"
                                        autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Street Required"></span> -->
                                    <span
                                        *ngIf="txtStreetName.invalid && (txtStreetName.dirty || txtStreetName.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtStreetName.errors?.required">
                                            {{'StreetName is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'District Name'|translate}}</label>
                                    <input type="text" class="form-control" required name="txtDistName" id="txtDistName"
                                        [(ngModel)]="proposalObj.Insured_DistName"
                                        [disabled]="proposalObj.districtExists" #txtDistName="ngModel"
                                        autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="District Required"></span> -->
                                    <span
                                        *ngIf="txtDistName.invalid && (txtDistName.dirty || txtDistName.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtDistName.errors?.required">
                                            {{'District Name is required'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Postal Code'|translate}}</label>
                                    <input type="text" class="form-control" required name="txtPostalCode"
                                        id="txtPostalCode" [(ngModel)]="proposalObj.Insured_POPostalCode"
                                        [disabled]="proposalObj.postCodeExists" #txtPostalCode="ngModel" minlength="5"
                                        maxlength="5" pattern="^[1-9]\d*$" autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Postl Code Required"></span> -->
                                    <span
                                        *ngIf="txtPostalCode.invalid && (txtPostalCode.dirty || txtPostalCode.touched || isSubmitted)"
                                        class="text-danger">
                                        <div *ngIf="txtPostalCode.errors?.required">
                                            {{'PostalCode is required'|translate}}
                                        </div>
                                        <div *ngIf="txtPostalCode.errors?.pattern">
                                            {{'PostalCode must Allow Only Numerics and Should Not start with Zero'|
                                            translate }}
                                        </div>
                                        <div *ngIf="txtPostalCode.errors?.minlength">
                                            {{'PostalCode must be 5 digits'|translate}}
                                        </div>
                                        <div *ngIf="txtPostalCode.errors?.maxlength">
                                            {{'PostalCode must be 5 digits'|translate}}
                                        </div>
                                    </span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" *ngIf="false">
                                    <label class="lbltext">{{ 'Email Id'| translate}}*</label>
                                    <input type="email" id="txtEmail" required name="txtEmail" autocomplete="off"
                                        [(ngModel)]="proposalObj.Insured_EmailId" class="form-control"
                                        #txtEmail="ngModel"
                                        pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?!\.)(?!.*?\.\.)(?!.*\.$)[a-zA-Z.]{2,10}$"
                                        placeholder="{{'Enter Email ID'|translate}}">
                                    <span
                                        *ngIf="txtEmail.errors && (txtEmail.dirty || txtEmail.touched || isSubmitted )"
                                        class="text-danger valid">
                                        <div *ngIf="txtEmail.errors.required">{{'Email is required'|translate}}</div>
                                        <div *ngIf="txtEmail.errors.pattern && txtEmail.invalid && txtEmail.touched ">
                                            {{'Invalid Email Format'|translate}} </div>
                                    </span>
                                </div>

                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12" *ngIf="false">
                                    <label class="lbltext">{{ 'Mobile No'| translate}}*</label>
                                    <input type="text" id="txtMobile" numbersOnly autocomplete="off" required
                                        maxlength=9 minlength="9" name="txtMobile" pattern="^5\d{8}$"
                                        [(ngModel)]="proposalObj.Insured_MobileNo" class="form-control Mobiles MBLE"
                                        #txtMobile="ngModel" placeholder="5XXXXXXXX">
                                    <span
                                        *ngIf="txtMobile.errors && (txtMobile.dirty || txtMobile.touched || isSubmitted)"
                                        class="text-danger valid">
                                        <div *ngIf="txtMobile.errors.required">{{'Mobile No is required'|translate}}
                                        </div>
                                        <div
                                            *ngIf="txtMobile.errors.pattern && txtMobile.invalid && txtMobile.touched ">
                                            {{'Mobile Number must be like (05XXXXXXXX)'|translate}} </div>
                                    </span>
                                </div>

                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Address Type'|translate}}*</label>
                                    <select class="form-control" id="txtAddessType" name="txtAddressType" required
                                        [(ngModel)]="proposalObj.AddressType" #txtAddressType="ngModel"
                                        autocomplete="off">
                                        <option value="">--{{'Select Address Type'|translate}}--</option>
                                        <option value="WaselAddress">{{'Wasel Address'| translate }}</option>
                                        <option value="PostalAddress">{{'Postal Address'| translate }}</option>
                                    </select>
                                    <span
                                        *ngIf="txtAddressType.invalid && (txtAddressType.dirty || isSubmitted || txtAddressType.touched)"
                                        class="text-danger">
                                        <div *ngIf="txtAddressType.errors?.required">
                                            {{'Address Type is required'|translate}}
                                        </div>
                                    </span>
                                </div>

                            </div>
                        </div>


                        <div class="Field">
                            <div class="row">
                                
                              

                          

                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Preffered Communication Language'| translate
                                    }}*</label>
                                    <select required class="form-control" id="txtPreferCommLang" name="txtPreferCommLang" [(ngModel)]="proposalObj.PreferCommLang" #txtPreferCommLang="ngModel">
                                        <option value="">
                                          ---{{'Select Communication Language' | translate}}---
                                        </option>
                                        <option value="E">{{'English' | translate}}</option>
                                        <option value="A">{{'Arabic' | translate}}</option>
                                      </select>
                                    
                                      <div *ngIf="txtPreferCommLang.errors && (txtPreferCommLang.dirty || txtPreferCommLang.touched || isSubmitted)" class="text-danger valid">
                                        <span *ngIf="txtPreferCommLang.errors.required">{{'Communication Language is required.'|translate
                                          }}</span>
                                      </div>
                                </div>

                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label class="lbltext">{{'Preffered Communication Channel'| translate}}*</label>
                                    <select selectRequired class="form-control" id="txtPreferCommChannel" name="txtPreferCommChannel" [(ngModel)]="proposalObj.PreferCommChannel" #txtPreferCommChannel="ngModel" required>
                                        <option value="">
                                          ---{{'Select Communication Channel' | translate}}---
                                        </option>
                                        <option value="SMS">{{'SMS' | translate}}</option>
                                        <option value="Email">{{'Email' | translate}}</option>
                                      </select>
                                      <div *ngIf="txtPreferCommChannel.errors && (txtPreferCommChannel.dirty || txtPreferCommChannel.touched || isSubmitted)" class="text-danger valid">
                                        <span *ngIf="txtPreferCommChannel.errors.required">{{'Communication Channel is required.'|translate }}</span>
                                      </div>
                                </div>

                            </div>
                        </div>

                        <div class="Field">
                            <div class="row">
                                
                                
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12"
                                    *ngIf="proposalObj.AddressType=='PostalAddress'">
                                    <label class="lbltext">{{'Post BoxNo'|translate}}*</label>
                                    <input type="text" class="form-control" numbersOnly
                                        [required]="proposalObj.AddressType=='PostalAddress'" name="txtPBox"
                                        id="txtPBox" [(ngModel)]="proposalObj.IPoBoxNo" #txtPBox="ngModel" maxlength="6"
                                        pattern="^[1-9]\d*$" autocomplete="off" />
                                    <!-- <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                        data-content="Postal Required"></span> -->
                                    <span *ngIf="txtPBox.invalid && (txtPBox.dirty || isSubmitted || txtPBox.touched)"
                                        class="text-danger">
                                        <div *ngIf="txtPBox.errors?.required">
                                            {{'Post BoxNo is required'|translate}}
                                        </div>
                                        <div *ngIf="txtPBox.errors?.pattern">
                                            {{ 'Post Box Number must not start with zero'| translate}}
                                        </div>
                                    </span>
                                </div>

                                
                            </div>
                        </div>



                        <div class="Field">
                            <div class="row">

                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12"
                                    *ngIf="this.proposalObj.Insured_Nationality=='17'">
                                    <label class="lbltext">{{'American ID'| translate }}</label>
                                    <input class="form-control" id="txtamericanID" name="txtamericanID" minlength="4"
                                        maxlength="15" required (keypress)="ValidateSpecialCharacters($event)"
                                        [(ngModel)]="proposalObj.AmericanID" #txtamericanID="ngModel">
                                    <span
                                        *ngIf="txtamericanID.invalid && (txtamericanID.dirty || txtamericanID.touched || isSubmitted)"
                                        class="text-danger valid">
                                        <div *ngIf="txtamericanID.errors?.required">
                                            {{'American ID is required'| translate }}</div>
                                        <div *ngIf="txtamericanID.errors?.minlength">
                                            {{'American ID must be atleast 3 digits' | translate}}</div>
                                        <div *ngIf="txtamericanID.errors?.maxlength">
                                            {{'American ID must be maximum 15 digits' | translate}}</div>
                                    </span>
                                </div>
                                <div class="col-lg-9 col-md-3 col-sm-12 col-xs-12">
                                </div>
                            </div>
                        </div>
                        <div class="Field">
                            <div class="row">
                                <div class="col-lg-8 col-sm-12 col-xs-12">
                                    <label class="lbltext">{{'IBAN Number'|translate}}*</label>
                                    <div class="row">
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <div class="input-group groupItems">
                                                <div class="input-group-addon">SA</div>
                                                <input type="text" class="form-control" id="txtIBAN1" name="txtIBAN1"
                                                    [(ngModel)]="proposalObj.IBAN1" maxlength="2" #txtIBAN1
                                                    [value]="txtIBAN1.value.toUpperCase()"
                                                    (ngModelChange)="iban1Changed($event)" required
                                                    autocomplete="off" />
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <input type="text" class="form-control" id="txtIBAN2" name="txtIBAN2"
                                                [(ngModel)]="proposalObj.IBAN2" maxlength="4"
                                                (blur)="setBankCode(proposalObj.IBAN2)"
                                                [disabled]="proposalObj.IBAN1?.length!=2" #txtIBAN2
                                                [value]="txtIBAN2.value.toUpperCase()"
                                                (ngModelChange)="iban2Changed($event)" autocomplete="off" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <input type="text" class="form-control" id="txtIBAN3" name="txtIBAN3"
                                                [(ngModel)]="proposalObj.IBAN3" maxlength="4"
                                                [disabled]="proposalObj.IBAN2?.length!=4" #txtIBAN3
                                                [value]="txtIBAN3.value.toUpperCase()"
                                                (ngModelChange)="iban3Changed($event)" autocomplete="off" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <input type="text" class="form-control" id="txtIBAN4" name="txtIBAN4"
                                                [(ngModel)]="proposalObj.IBAN4" maxlength="4"
                                                [disabled]="proposalObj.IBAN3?.length!=4" #txtIBAN4
                                                [value]="txtIBAN4.value.toUpperCase()"
                                                (ngModelChange)="iban4Changed($event)" autocomplete="off" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <input type="text" class="form-control" id="txtIBAN5" name="txtIBAN5"
                                                [(ngModel)]="proposalObj.IBAN5" maxlength="4"
                                                [disabled]="proposalObj.IBAN4?.length!=4" #txtIBAN5
                                                [value]="txtIBAN5.value.toUpperCase()"
                                                (ngModelChange)="iban5Changed($event)" autocomplete="off" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                            <input type="text" class="form-control" id="txtIBAN6" name="txtIBAN6"
                                                [(ngModel)]="proposalObj.IBAN6" maxlength="4"
                                                [disabled]="proposalObj.IBAN5?.length!=4" #txtIBAN6
                                                [value]="txtIBAN6.value.toUpperCase()" autocomplete="off" />
                                        </div>
                                    </div>

                                    <span class="text-danger valid">*{{'IBAN Number must start with SA and enter 4 digits in each textbox(Ex:SA12 8056 7890 1234 6575 9898)'|translate}}</span>
                                </div>

                            </div>
                        </div>
                        <div class="Field">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <label class="lbltext">{{'Bank Name'|translate}}*</label>
                                    <select class="form-control" id="txtBankName" name="txtBankName"
                                        [(ngModel)]="proposalObj.BankCode" [disabled]="true">
                                        <option [value]="">--{{'Select Bank'|translate}}---</option>
                                        <option *ngFor="let bank of medmalBindObj.bankList" [value]="bank.BankCode">
                                            {{bank.BankDesc_Eng}}</option>
                                    </select>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label class="lbltext">{{'Are you a political person or holding a high position in the government ?'| translate }}*</label>
                                    <select class="form-control" id="txtIsHigherPosition" name="txtIsHigherPosition"
                                        [(ngModel)]="proposalObj.IsHigherPosition"
                                        (ngModelChange)="IsHigherPosition(proposalObj.IsHigherPosition)"
                                        #txtIsHigherPosition="ngModel">
                                        <option [value]=true>{{'Yes' | translate}}</option>
                                        <option [value]=false>{{'No' | translate}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="Field">
                            <div class="row">
                                <!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <label class="lbltext">{{ 'Assist'| translate}}</label>
                                    <input type="text" name="txtAssist" id="txtAssist" class="form-control"
                                        [(ngModel)]="proposalObj.ReferredBy" (keypress)="ValidateSpecialCharacters($event)"
                                        #txtAssist="ngModel">
    
                                 </div> -->
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                    *ngIf="ShowHigherPositionFeild || proposalObj.IsHigherPosition">
                                    <div class="col-lg-12">
                                        <label class="lbltext">{{'Higher Position'| translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 higherpositionmedmal">
                                        <select class="form-control" selectRequired id="txtHigherPosition"
                                            name="txtHigherPosition" [(ngModel)]="proposalObj.HigherPositionCode"
                                            #txtHigherPosition="ngModel">
                                            <option [value]=0>{{'Select Higher Position' | translate}}</option>
                                            <option [value]=1>{{'Prince' | translate}}</option>
                                            <option [value]=2>{{'Minister' | translate}}</option>
                                            <option [value]=3>{{'Officer' | translate}}</option>
                                            <option [value]=4>{{'Diplomatic Representative' | translate}}</option>
                                            <option [value]=5>{{'Business Owner' | translate}}</option>
                                        </select>
                                        <!-- <span data-toggle="modal" data-target="#HigherPosition"
                                            class="glyphicon glyphicon-question-sign field-tip-HigherPosition">
                                            <span class="tip-content" data-content="Click Me!">{{'Click Me'|
                                                translate}}</span>
                                        </span> -->
                                    </div>
                                    <div *ngIf="txtHigherPosition.invalid && (txtHigherPosition.dirty || txtHigherPosition.touched || isSubmitted)"
                                        class="text-danger valid">
                                        <span *ngIf="txtHigherPosition.errors?.selectRequired">{{'Higher Position is required.'|translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row checkAccept">
                            <div class="col-lg-12">
                                <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms AgreeCheckBox"
                                    [(ngModel)]="agreeKYC" style=" zoom: 1.5;" />
                                <span class="kycdeclare">{{'I here by declare the KYC details are correct' | translate}}
                                    <a style="color: green; text-decoration: underline;font-size: 12px;"
                                        onMouseOver="this.style.color='maroon'" onMouseOut="this.style.color='green'"
                                        data-toggle="modal" data-target="#ViewKYCDetails">{{'View KYC Details'|
                                        translate}}</a>
                                </span>

                            </div>
                        </div>
                        <div class="row acceptchck">
                            <div class="col-lg-9">
                                <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms medmalagreeterms"
                                    [(ngModel)]="agreeTerms" style=" zoom: 1.5;" />
                                <a href="TermsURl" style="font-weight:bold;" target='_blank' download>{{'I Agree to Policy Terms and Conditions'| translate}}</a>
                            </div>
                        </div>

                        <div class="row acceptchck">
                            <div class="col-lg-9">
                                <input type="checkbox" id="Chkterms" name="Chkterms" class="agreeTerms medmalagreeterms"
                                    [(ngModel)]="agreeNatAdd" style=" zoom: 1.5;" />
                                <a data-toggle="modal" data-target="#myModal" style="font-weight:bold;" target='_blank'
                                    download>{{'I Agree to National Address Declaration'| translate}}</a>
                            </div>
                        </div>



                        <div id="myModal" class="modal fade">
                            <div class="modal-dialog">
                                <div class="modal-content" style="top: 300px;">
                                    <div class="modal-header" style="background-color: #004085;">
                                        <button type="button" class="close" data-dismiss="modal">X</button>
                                        <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
                                            {{'National Address Declaration' | translate }}
                                        </h4>
                                    </div>
                                    <div class="modal-body">
                                        <p class="NatDecAr">{{'National Address Declaration Text Medmal' | translate }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </form>
                    <br />
                    <hr class="hr" />
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display: flex;flex-direction:row;justify-content: space-between">
                            
                                <div class="btn-group">
                                    <button class="btn btn-primary btnNext" name="btnNext" id="btnNext"
                                        (click)="GoPrev()">{{'Prev'|translate}}</button>
                                </div>
                                <div class="btn-group">
                                    <button class="btn btn-primary btnNext" name="btnNext" id="btnNext"
                                        (click)="GoNext(insuredForm.valid)"
                                        [disabled]="!agreeTerms || !agreeKYC">{{'Next'|translate}}</button>
                                </div>
                            
                        </div>
                        
                    </div>
                    
                    <div class="clears">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>








<div class="modal fade" id="HigherPosition" data-backdrop="static" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
            <div class="modal-header" style="background-color: #004085;">
                <button type="button" style="opacity:1;color:white;" class="close" data-dismiss="modal"
                    #closeBtn>X</button>
                <h4 class="modal-title" style="color: white;font-size: 14px !important;">
                    {{'Higher Position' | translate }}</h4>
            </div>
            <div class="modal-body">
                <table class="table table-bordered table-hover">
                    <thead class="tablehead">
                        <tr>
                            <td>{{'Position' | translate}}</td>
                            <td>{{'Nature of work' | translate}}</td>
                            <td>{{'Grade/Field' | translate}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{'Prince'| translate}}</td>
                            <td>
                                <ul>
                                    <li>{{'Political' | translate}}</li>
                                    <li>{{'Business' | translate}}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>{{'Royal Highness' | translate}}</li>
                                    <li>{{'All kinds of Business' | translate}}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>{{'Minister' | translate}}</td>
                            <td>
                                <ul>
                                    <li>{{'Governmental Employees' | translate}}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>{{'Grade 15+( High Grades)' | translate}}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>{{'Officer' | translate}}</td>
                            <td>
                                <ul>
                                    <li>{{'Police' | translate}}</li>
                                    <li>{{'Army' | translate}}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>{{'Colonel +' | translate}}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>{{'Diplomatic Representative' | translate}}</td>
                            <td>
                                <ul>
                                    <li>{{'Citizen' | translate}}</li>
                                    <li>{{'Foreign' | translate}}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>{{'Ambassador' | translate}}</li>
                                    <li>{{'Consul' | translate}}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>{{'Business Owner' | translate}}</td>
                            <td>
                                <ul>
                                    <li>{{'Citizen' | translate}}</li>
                                    <li>{{'Foreign' | translate}}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>{{'Real Estate' | translate}}</li>
                                    <li>{{'Gold ' | translate}}</li>
                                </ul>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="ViewKYCDetails" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" style="color:black" data-dismiss="modal">X</button>
                <h4 class="modal-title logins">{{'KYC Details'| translate}}</h4>
            </div>
            <div class="modal-body">
                <div class="kyccard">
                    <div class="kyccard-header">
                        <p class="kyccard-heading">{{'Insured Info' | translate}}</p>
                    </div>
                    <div class="kyccard-body">
                        <div class="row cardsrow">
                            <div class="kycinnercard col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Insured Name' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_Name}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'ID Number' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_IDNo}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Mobile' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_MobileNo}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Email Id' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_EmailId}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'ID Expiry' | translate}}:</span>
                                    <span class="kyclabelvalue">{{proposalObj.IDExpiry}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Additional Code' | translate}}:</span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_AdditionalCode}}</span>
                                </div>
                            </div>
                            <div class="kycinnercard col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'City' | translate}}: </span>
                                    <span class="kyclabelvalue">{{CityName}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Area Name' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_AreaName}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Street Name' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_StreetName}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Building No' | translate}}: </span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_BuildingNo}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Unit No' | translate}}:</span>
                                    <span
                                        class="kyclabelvalue">{{proposalObj.Insured_UnitNo?proposalObj.Insured_UnitNo:0}}</span>
                                </div>
                                <div class="kycrow">
                                    <span class="kyclabeldata">{{'Postal Code' | translate}}:</span>
                                    <span class="kyclabelvalue">{{proposalObj.Insured_POPostalCode}}</span>
                                </div>
                            </div>
                        </div>
                        <hr class="lineclass">
                        <div class="row" style="margin:10px;">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-5 kyclabelrow">
                                <label class="kyclabel">{{'American Citizen?' | translate }} </label>
                                <label class="kyclabel kycvalue">
                                    <label *ngIf="this.proposalObj.Insured_Nationality=='17'">{{'Yes' | translate
                                        }}</label>
                                    <label *ngIf="this.proposalObj.Insured_Nationality!='17'">{{ 'No' | translate
                                        }}</label>
                                </label>
                            </div>
                            <div class="col-lg-4 col-md-5 col-sm-8 col-xs-7 kyclabelrow">
                                <label class="kyclabel">{{'If yes, American ID No' | translate }}: </label>
                                <label class="kyclabel kycvalue">{{proposalObj.AmericanID}}</label>
                            </div>
                        </div>
                        <div class="row" style="margin:10px;">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 kyclabelrow">
                                <label class="kyclabel">{{'Political Person? ' | translate }} </label>
                                <label class="kyclabel kycvalue">
                                    <label *ngIf="proposalObj.IsHigherPosition">{{'Yes' | translate }}</label>
                                    <label *ngIf="!proposalObj.IsHigherPosition">{{ 'No' | translate }}</label>
                                </label>
                            </div>
                            <div class="col-lg-6 col-md-7 col-sm-8 col-xs-12 kyclabelrow">
                                <label class="kyclabel">{{'If yes, Please specify job title and rank' | translate }}:
                                </label>
                                <label class="kyclabel kycvalue"
                                    *ngIf="this.proposalObj.HigherPositionCode==1">{{'Prince' | translate}}</label>
                                <label class="kyclabel kycvalue"
                                    *ngIf="this.proposalObj.HigherPositionCode==2">{{'Minister' | translate}}</label>
                                <label class="kyclabel kycvalue"
                                    *ngIf="this.proposalObj.HigherPositionCode==3">{{'Officer' | translate}}</label>
                                <label class="kyclabel kycvalue"
                                    *ngIf="this.proposalObj.HigherPositionCode==4">{{'Diplomatic Representative' |
                                    translate}}</label>
                                <label class="kyclabel kycvalue"
                                    *ngIf="this.proposalObj.HigherPositionCode==5">{{'Business Owner' |
                                    translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="PayMethods">
	<img src="assets/img/payment-footer-en1.png">
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalInsuredInfo/MedmalInsuredInfo.html